import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { Button } from "@/components/ui/button"
import { combineCareProviderTitle } from "@/modules/care-provider/utils/combine-care-provider-title"
import type { ClosestCareProvider } from "@/modules/patients/detail/progress-note/point-of-care/hooks/useCheckPartnerPortalEligibility"

type PartnerPortalBannerProps = {
  onRefer: () => void
  isLoading?: boolean
  closestCareProvider?: ClosestCareProvider | null
}

export const PartnerPortalBanner = ({ onRefer, isLoading, closestCareProvider }: PartnerPortalBannerProps) => {
  const { t } = useTranslation()

  return (
    <Banner type="inline" variant="info" data-testid="partner-portal-banner" iconClassName="self-center">
      <div className="ml-4 flex w-full items-center justify-between gap-2">
        <div className="flex flex-col">
          <span>{t("partnerPortal.bannerMessage")}</span>
          {closestCareProvider && closestCareProvider.distanceKm && (
            <span className="text-muted-foreground text-sm" data-testid="partner-portal-closest-care-provider">
              {t("partnerPortal.closestCareProvider", {
                name: combineCareProviderTitle({
                  businessName: closestCareProvider.businessName,
                  title: closestCareProvider.title,
                  firstName: closestCareProvider.firstName,
                  lastName: closestCareProvider.lastName,
                }),
                distance: closestCareProvider.distanceKm.toFixed(2),
              })}
            </span>
          )}
        </div>
        <Button
          variant="tertiary"
          onClick={onRefer}
          disabled={isLoading}
          data-testid="partner-portal-refer-button"
          className="text-accent">
          {t("partnerPortal.referButton")}
        </Button>
      </div>
    </Banner>
  )
}
